"use strict";

(function () {

	/*
	 * add focus class to all siblings when input is focused
	 */
	let input = document.querySelector(".q-search__input");

	if (input) {

		input.addEventListener("focus", function () {

			input.parentNode.childNodes.forEach(node => {

				if (node.nodeType === Node.ELEMENT_NODE) {
					node.classList.add("focus");
				}

			});

		});

		input.addEventListener("blur", function () {

			input.parentNode.childNodes.forEach(node => {

				if (node.nodeType === Node.ELEMENT_NODE) {
					node.classList.remove("focus");
				}

			});

		});

	}


	/*
	 * reset input when reset button is clicked
	 */
	let button = document.querySelector(".q-search__close");

	if (button) {

		button.addEventListener("click", function () {

			input.value = "";
			input.focus();

		});

	}

}());
